(ns com.theplantscape.web-ui.error-boudary
  (:require    [reagent.core :as r]))

(defn error-boundary-component [comp]
  (r/create-class
   {:constructor (fn [this props]
                   (set! (.-state this) #js {:error nil}))
    :component-did-catch (fn [this e info])
    :get-derived-state-from-error (fn [error] #js {:error error})
    :render (fn [this]
              (r/as-element
               (if-let [error (.. this -state -error)]
                 [:div
                  [:pre (str error)]
                  [:div
                   "Something went wrong."
                   [:button {:on-click #(.setState this #js {:error nil})} "Try again"]]]
                 comp)))}))
